import { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { useAuth } from '../../contexts/AuthContext';
import { Download } from 'lucide-react';

interface ImportFromStoreButtonProps {
  onImport: () => void;
}

export default function ImportFromStoreButton({ onImport }: ImportFromStoreButtonProps) {
  const [hasIntegrations, setHasIntegrations] = useState(false);
  const { currentUser } = useAuth();

  useEffect(() => {
    checkIntegrations();
  }, [currentUser]);

  const checkIntegrations = async () => {
    if (!currentUser?.companyId) return;

    try {
      const integrationsRef = collection(db, 'integrations');
      const q = query(
        integrationsRef,
        where('companyId', '==', currentUser.companyId),
        where('active', '==', true),
        where('type', 'in', ['woocommerce', 'shopify']) // Apenas integrações de e-commerce
      );

      const querySnapshot = await getDocs(q);
      console.log('Integrações encontradas:', querySnapshot.size);
      querySnapshot.forEach(doc => {
        console.log('Integração:', doc.data());
      });
      
      setHasIntegrations(!querySnapshot.empty);
    } catch (error) {
      console.error('Erro ao verificar integrações:', error);
      setHasIntegrations(false);
    }
  };

  // Se ainda estiver carregando ou não tiver integrações, não mostra o botão
  if (!hasIntegrations) {
    console.log('Sem integrações ativas, botão não será mostrado');
    return null;
  }

  return (
    <button
      onClick={onImport}
      className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
    >
      <Download className="mr-2 h-4 w-4" />
      Importar da Loja
    </button>
  );
}
